
function flattenObject(obj, parent = '', res = {}) {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            const propName = parent ? `${parent}.${key}` : key;
            
            if (obj[key] === null || obj[key] === undefined) {
                res[propName] = '';
            } else if (typeof obj[key] === 'object') {
                if (Array.isArray(obj[key])) {
                    if (obj[key].length === 0) {
                        res[propName] = '';
                    } else if (typeof obj[key][0] === 'object') {
                        // Para arrays de objetos, aplanar cada elemento
                        obj[key].forEach((item, index) => {
                            flattenObject(item, `${propName}[${index}]`, res);
                        });
                    } else {
                        // Para arrays de valores primitivos, unir con comas
                        res[propName] = obj[key].join(', ');
                    }
                } else {
                    // Para objetos anidados, aplanar recursivamente
                    flattenObject(obj[key], propName, res);
                }
            } else {
                res[propName] = obj[key];
            }
        }
    }
    return res;
}

export { flattenObject };